import { Badge, Group, Text, UnstyledButton } from '@mantine/core'
import { timeAgo, statusLabel } from '@/lib/session-utils'
import type { AgentSessionProps } from '@/types'

type ChatListItemProps = {
  session: AgentSessionProps
  active: boolean
  onClick: () => void
  matchPreview?: string | null
}

export default function ChatListItem({ session, active, onClick, matchPreview }: ChatListItemProps) {
  const label = statusLabel(session.status)

  return (
    <UnstyledButton
      onClick={onClick}
      style={{
        display: 'block',
        width: '100%',
        padding: '10px 16px',
        borderLeft: active
          ? '3px solid var(--mantine-color-teal-5)'
          : '3px solid transparent',
        backgroundColor: active
          ? 'var(--mantine-color-teal-0)'
          : 'transparent',
      }}
    >
      <Text fw={500} size="sm" lineClamp={1}>
        {session.title || session.preview || 'New conversation'}
      </Text>
      {matchPreview && (
        <Text c="dimmed" size="xs" lineClamp={2} mt={2} fs="italic">
          {matchPreview}
        </Text>
      )}
      <Group gap={8} mt={4}>
        {label && (
          <Badge
            variant="dot"
            size="xs"
            color={
              session.status === 'failed'
                ? 'red'
                : session.status === 'waiting_for_user'
                  ? 'yellow'
                  : 'gray'
            }
          >
            {label}
          </Badge>
        )}
        <Text c="dimmed" size="xs">
          {timeAgo(session.last_activity_at || session.started_at)}
        </Text>
      </Group>
    </UnstyledButton>
  )
}
